import "../styles/App.css";
import "../styles/pages/Team.css";

import Header from "../components/Header";
import ImageCard from "../components/ImageCard";
import useIsMobile from "../hooks/useIsMobile";
import Carousel from "../components/ImageCarousel";

type Psicologa = {
  img: string;
  name: string;
  desc: string[];
};

const psicologas: Psicologa[] = [
  {
    img: "/images/psic1.png",
    name: `Mariana Nunes Rodrigues`,
    desc: [
      "Membro OPP, cédula nº 134109",
      "Diretora Clínica da MNR - Clínica de Psicologia",
      "Estágio curricular no Hospital de Dia, Programa A, ULSSM - Unidade Local de Saúde Santa Maria",
      "Mestrado em Psicologia Clínica e da Saúde, ISPA",
      "Licenciatura em Ciências Psicológicas, ISPA",
    ],
  },

  {
    img: "/images/psic2.png",
    name: `Rafaela da Fonseca`,
    desc: [
      "Membro OPP, cédula nº 134429",
      "Psicóloga na MNR - Clínica de Psicologia",
      "Estágio curricular no Hosp. Prof. Dr. Fernando Fonseca, no Serv. de Psiquiatria e Saúde Mental de Adultos",
      "Mestrado em Psicologia Clínica e da Saúde, ISPA",
      "Licenciatura em Ciências Psicológicas, ISPA",
    ],
  },
];

function Team() {
  const isMobile = useIsMobile(801);
  const teamRender = psicologas.map((user) =>  <ImageCard icon={user.img} title={user.name} content={user.desc} />);
  return (
    <div id="team" className="section">
      <div className="teamWrapper">
        <Header content="A Nossa Equipa" />
        <br/>
        <div className="cardWrapper">
          {isMobile? <Carousel items={teamRender} slideInterval={0}/> : <div className="cardWrapper"> {teamRender} </div>}
        </div>
      </div>
    </div>
  );
}

export default Team;
